// extracted by mini-css-extract-plugin
module.exports = {"icon":"style-module__icon___2UFkA","blue":"style-module__blue___spm3m","error":"style-module__error___OZi2b","clickable":"style-module__clickable___wsYOj"};